import React from 'react';
import {FieldProp} from '../../types';

type HtmlProps = FieldProp & {};

export const Html: React.FunctionComponent<HtmlProps> = ({field, value}): JSX.Element => {
    const v = value || field.content;
    return (
        <div dangerouslySetInnerHTML={{__html: v}} />
    );
};